"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _this = void 0;

var _default = function _default(func) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return typeof func === "function" ? func.apply(_this, args) : null;
};

exports["default"] = _default;